import { makeObservable } from 'mobx'
import moment from 'moment'
import { formatPhoneNumber } from '../../../helpers/ordersUtiles'
import { isOperator } from '../../../services/AccountService'
import FormStore from '../../../utils/stores/FormStore'

const initState = {
  phoneNumber: '',
  address: '',
  equipmentId: '',
  preferentialCategories: [],
  surname: '',
  name: '',
  patronymic: '',
  territory: '',
  district: '',
  locality: '',
  addressType: '',
  house: '',
  building: '',
  apartment: '',
  preferentialCategory: '',
  created: '',
  additionalInfo: '',
  senderId: '',
  maintenanceReasonId: 1,
  incidentTypeId: '',
  isUrgent: false,
  malfunctionTypeId: '',
  malfunctionExplanation: '',
  requireReasonDiscription: false,
  installedOrderId: '',
  orderId: null,
  isReqired: false,
  serviceCenterComment: '',
}

const validateData = {
  surname: { required: true },
  name: { required: true },
  territory: { required: true },
  district: { required: true },
  address: { required: true },
  locality: { required: true },
  phoneNumber: {
    required: true,
    validators: [
      (value) => {
        value = formatPhoneNumber(value)
        return !/^\+7 \(\d{3}\)-\d{3}-\d{2}-\d{2}$/.test(value)
      },
    ],
  },
  created: {
    required: true,
    validators: [
      (value) => value.length < 16,
      (value) => {
        return (
          moment().utc(true).diff(moment(value, 'DD-MM-YYYY,HH:mm').utc(true)) <
          0
        )
      },
    ],
  },
  senderId: { required: true },
  maintenanceReasonId: { required: true },
}

class ServiceAddRequestFormStore extends FormStore {
  constructor() {
    const validateDataNew = { ...validateData }

    if (isOperator()) {
      validateDataNew.malfunctionTypeId = { required: true }
      validateDataNew.incidentTypeId = { required: true }
    }

    super({ initState, validateData: validateDataNew })
    this.showErrors = true
    this.isValid = false
    makeObservable(this, {})
  }

  clear = (savedFields = []) => {
    // если  нужно на каком-то этапе сохранить какие-то поля при сбросе
    const updatedState = { ...initState }
    savedFields.forEach((field) => {
      updatedState[field] = this.data[field]
    })

    this.setData(updatedState)
    this.clearSelectedFilters()
  }
}

export default ServiceAddRequestFormStore
